import { render, staticRenderFns } from "./AddTaskModal.vue?vue&type=template&id=efb6a00e&scoped=true&"
import script from "./AddTaskModal.vue?vue&type=script&lang=ts&"
export * from "./AddTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddTaskModal.vue?vue&type=style&index=0&id=efb6a00e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb6a00e",
  null
  
)

export default component.exports